import React, { useState } from 'react'
import { useHistory, useLocation } from "react-router-dom";
import { ChevronLeft } from 'react-feather'
import { Container } from '../../../components'
import { useSelector } from 'react-redux';
import AudienceListener from '../../../features/collection/components/audience-listener';
import { useInternationalization } from '../../../features/i18n';
import MapFilter from '../../../features/search/components/map-filter';
import Dropdown from 'react-dropdown'

const MapHeader = ({organizationId}) => {
  const location = useLocation()
  const history = useHistory()
  const { isOfficial, isVerified} = useSelector(state => state.account)
  const { translate, language } = useInternationalization()
  const [ show, setShow ] = useState(false)

  const handleBack = () => {
    if(organizationId){
      history.push(`/organization/${organizationId}/program`)
    } else {
      history.push('/program')
    }
  }

  const backLinkText = organizationId ? (
    translate('RELATED', 'back_to_organization_detail')
  ) : (
    translate('RELATED', 'back_to_program_list')
  )

  const handleChange = ({value}) => {
    if(value === 'base'){
      handleBack()
    } else {
      let pathname = '/program'

      if(value === 'statistic'){
        pathname = '/program-statistic'
      }

      history.push({
        pathname,
        search: location.search
      })
    }
  }

  React.useEffect(() => {
    setShow(false)
    setTimeout(() => setShow(true), 100)

    //eslint-disable-next-line
  }, [language])

  return (
    <Container
      className={`${organizationId ? '' : 'page-header'} ${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5 lg:py-3 relative z-20`}
      color="#f5f5f5"
    >
      <AudienceListener />
      <div className="flex justify-between items-center">
        <div className="flex items-center cursor-pointer mr-4">
          <ChevronLeft style={{width: '24px'}} className="mr-4"/>
          {
            show &&
            <Dropdown
              options={[
                {
                  label: backLinkText,
                  value: 'base',
                },
                {
                  label: translate('VIEW', 'statistic'),
                  value: 'statistic',
                },
              ]}
              onChange={handleChange}
              placeholder={translate('NAVIGATION', 'back')}
              className="map-header-dropdown"
            />
          }
        </div>

        <MapFilter />
      </div>
    </Container>
  )
}

export default MapHeader
